<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" title="Đặt lại mật khẩu" icon="fas fa-key" />
    <el-form
      v-if="user"
      :model="resetPasswordForm"
      :rules="rules"
      ref="resetPasswordForm"
      :hide-required-asterisk="true"
    >
      <h5 class="text-center">Đặt mật khẩu cho "{{ user.email }}"</h5>
      <br />
      <el-form-item label="Mật khẩu mới" prop="password">
        <el-input v-model="resetPasswordForm.password" type="password" />
      </el-form-item>
      <el-form-item label="Nhập lại mật khẩu mới" prop="confirmPassword">
        <el-input v-model="resetPasswordForm.confirmPassword" type="password" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
      <CommonButton type="primary" @click="onSubmit" :ref="refs.CONFIRM_BUTTON">Thay đổi</CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import { resetPasswordByAdmin } from '@/services/authentication_service'
import ModalHeader from '@/components/common/ModalHeader.vue'
import CommonButton from '@/components/common/CommonButton.vue'

export default {
  name: 'PasswordResetAdminModal',
  components: { CommonButton, ModalHeader },
  data() {
    let validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Nhập lại mật khẩu'))
      } else if (value !== this.resetPasswordForm.password) {
        callback(new Error('Mật khẩu không khớp'))
      } else {
        callback()
      }
    }
    return {
      show: false,
      user: null,
      resetPasswordForm: {
        password: null,
        email: null,
        confirmPassword: null,
      },
      rules: {
        password: [
          {
            required: true,
            message: 'Hãy nhập mật khẩu mới',
            trigger: 'change',
          },
          {
            min: 8,
            message: 'Mật khẩu tối thiểu 8 kí tự',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: 'Hãy nhập lại mật khẩu mới',
            trigger: 'change',
          },
          {
            min: 8,
            message: 'Mật khẩu tối thiểu 8 kí tự',
            trigger: 'change',
          },
          { validator: validateConfirmPassword, trigger: 'change' },
        ],
      },
      refs: {
        CONFIRM_BUTTON: 'CONFIRM_BUTTON',
      },
    }
  },
  methods: {
    showModal(user) {
      this.user = user
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    onSubmit() {
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$refs[this.refs.CONFIRM_BUTTON].setLoading(true)
        try {
          resetPasswordByAdmin(
            this.user.email,
            this.resetPasswordForm.password,
            this.resetPasswordForm.confirmPassword
          )
          this.$message.success('Đặt lại mật khẩu thành công')
          this.show = false
        } catch (e) {
          this.$message.error('Có lỗi xảy ra')
        } finally {
          this.$refs[this.refs.CONFIRM_BUTTON].setLoading(false)
        }
      })
    },
  },
}
</script>
